module.exports = __webpack_public_path__ + "static/headless-matt-zoom-73b3bec036715c83c9d9ee81919a6ad6.jpg";